
import { Vue, Component } from "vue-property-decorator";
import { formatDay, hostingLabel, loadMarketplace } from "@/data/MarketplaceSites";

@Component
export default class MarketplaceSites extends Vue {
  rows: any[] = [];
  loading = false;
  error = "";
  search = "";
  settings = { graceDays: 7, frozenDays: 90 };
  day = formatDay;

  headers = [
    { text: "Адрес сайта", value: "address" },
    { text: "Клиент", value: "client" },
    { text: "Шаблон", value: "template" },
    { text: "Хостинг", value: "hostingPaidUntil" },
    { text: "Создан", value: "createDate" },
    { text: "Заказ", value: "order", sortable: false },
  ];

  breadcrumbs = [
    { text: "Главная", to: "/" },
    { text: "Маркетплейс сайтов", disabled: true },
    { text: "Сайты клиентов", disabled: true },
  ];

  async created() {
    await this.load();
  }

  async load() {
    this.loading = true;
    this.error = "";
    try {
      const data = await loadMarketplace("sites");
      this.settings = { graceDays: data.graceDays, frozenDays: data.frozenDays };
      this.rows = data.items.map((s: any) => ({
        ...s,
        client: s.client?.name ?? "—",
        email: s.client?.email ?? "",
        template: s.template ?? "—",
        hosting: hostingLabel(s),
      }));
    } catch (e: any) {
      this.error = e?.response?.data?.message ?? "Не удалось загрузить сайты";
    } finally {
      this.loading = false;
    }
  }
}
